export const TRANSACTION_STAGES = [
  '协议准备',
  '协议签署中',
  '付款中',
  '工商变更',
  '完成交割',
] as const;

export const AGREEMENT_STATUSES = ['待签署', '签署中', '已签署'] as const;

export const PAYMENT_STATUSES = ['待付款', '付款中', '已付款'] as const;

export const CLOSING_STATUSES = ['进行中', '已完成'] as const;

export type TransactionStage = (typeof TRANSACTION_STAGES)[number];
export type AgreementStatus = (typeof AGREEMENT_STATUSES)[number];
export type PaymentStatus = (typeof PAYMENT_STATUSES)[number];
export type ClosingStatus = (typeof CLOSING_STATUSES)[number];

export const TRANSACTION_STEP_LABELS = [
  '协议准备',
  '协议签署',
  '付款',
  '工商变更',
  '完成交割',
] as const;

export const isAgreementComplete = (status: string) => status === '已签署';

export const isPaymentComplete = (status: string) => status === '已付款';

export const isClosingComplete = (status: string) => status === '已完成';

export const getTransactionStepIndex = (transaction: {
  stage: string;
  agreementStatus: string;
  paymentStatus: string;
  closingStatus: string;
}) => {
  if (isClosingComplete(transaction.closingStatus)) {
    return TRANSACTION_STEP_LABELS.length - 1;
  }
  const stageIndex = TRANSACTION_STAGES.indexOf(
    transaction.stage as TransactionStage,
  );
  if (stageIndex >= 0) return stageIndex;
  if (isPaymentComplete(transaction.paymentStatus)) return 2;
  if (isAgreementComplete(transaction.agreementStatus)) return 1;
  return 0;
};
